import Vue from 'vue'
import App from './App'
import store from '@/store'
import router from '@/router'
import i18n from '@/lang'
import * as svgicon from 'vue-svgicon'
import SocialSharing from 'vue-social-sharing'
import VueAnalytics from 'vue-analytics'
import '@/services/iframe'
import 'assets/fonts/fonts.scss'

Vue.config.productionTip = false
Vue.use(svgicon)
Vue.use(SocialSharing)

const isProd = process.env.NODE_ENV === 'production'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  i18n,
  router,
  render: h => h(App),
  created () {
    // Get all params
    store.dispatch('app/getSettings', router.history.current.params.id)
      .then(() => {
        // Initialise GA
        Vue.use(VueAnalytics, {
          id: store.getters['app/getGA'].value,
          router,
          debug: {
            enabled: !isProd,
            sendHitTask: isProd
          }
        })
      })
  }
})



// WEBPACK FOOTER //
// ./src/main.js